(() => {
  if (customElements.get('dtf-locker-pickup')) return;
  let busy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const widgets = () => [...document.querySelectorAll('dtf-locker-pickup')];
  const request = async (path, body) => {
    const response = await fetch(root() + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok || data.status >= 400 || data.errors) throw new Error('cart-request-failed');
    return data;
  };
  const setBusy = (value) => {
    busy = value;
    widgets().forEach(widget => {
      widget.setAttribute('aria-busy', String(value));
      widget.querySelector('input').disabled = value;
    });
    document.querySelectorAll('button[name="checkout"], .additional-checkout-buttons, cart-items, cart-drawer-items').forEach(element => {
      if (value && !element.inert) {
        element.inert = true;
        element.setAttribute('data-dtf-locker-inert', '');
      } else if (!value && element.hasAttribute('data-dtf-locker-inert')) {
        element.inert = false;
        element.removeAttribute('data-dtf-locker-inert');
      }
    });
  };
  const sync = (cart) => {
    widgets().forEach(widget => {
      const selected = cart.items.some(item => String(item.variant_id) === widget.dataset.variantId);
      widget.dataset.selected = String(selected);
      widget.querySelector('input').checked = selected;
    });
    widgets().forEach(widget => {
      document.querySelectorAll('[data-quantity-variant-id="' + widget.dataset.variantId + '"]').forEach(input => {
        input.readOnly = true;
        input.max = '1';
        input.closest('quantity-input')?.querySelectorAll('button').forEach(button => { button.disabled = true; });
      });
    });
  };
  class LockerPickup extends HTMLElement {
    connectedCallback() {
      this.querySelector('input').disabled = busy;
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        event.stopPropagation();
        if (event.target.matches('input[type="checkbox"]')) this.toggle(event.target.checked);
      }, { signal: this.controller.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.cartData?.items) sync(event.cartData);
        });
      }
      document.querySelectorAll('[data-quantity-variant-id="' + this.dataset.variantId + '"]').forEach(input => {
        input.readOnly = true;
        input.max = '1';
        input.closest('quantity-input')?.querySelectorAll('button').forEach(button => { button.disabled = true; });
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
    }
    async toggle(selected) {
      if (busy) {
        this.querySelector('input').checked = this.dataset.selected === 'true';
        return;
      }
      const variantId = Number(this.dataset.variantId);
      const previous = this.dataset.selected === 'true';
      this.querySelector('[role="alert"]').hidden = true;
      setBusy(true);
      let updated = false;
      try {
        const cart = await request('cart.js');
        const lines = cart.items.filter(item => item.variant_id === variantId);
        const sections = { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
        let result;
        if (selected && !lines.length) {
          result = await request('cart/add.js', { items: [{ id: variantId, quantity: 1 }], ...sections });
        } else if (lines.length) {
          const updates = Object.fromEntries(lines.map((item, index) => [item.key, selected && index === 0 ? 1 : 0]));
          result = await request('cart/update.js', { updates, ...sections });
        } else {
          sync(cart);
          return;
        }
        updated = true;
        const drawer = document.querySelector('cart-drawer');
        if (document.getElementById('main-cart') || !drawer?.renderContents || !drawer.querySelector('.drawer__inner') || !result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) {
          window.location.reload();
          return;
        }
        drawer.renderContents(result, true);
        const currentCart = await request('cart.js');
        sync(currentCart);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: currentCart, variantId });
        }
        requestAnimationFrame(() => drawer.querySelector('dtf-locker-pickup input')?.focus());
      } catch (error) {
        if (updated) {
          window.location.reload();
          return;
        }
        try { sync(await request('cart.js')); }
        catch { widgets().forEach(widget => { widget.querySelector('input').checked = previous; }); }
        widgets().forEach(widget => {
          const alert = widget.querySelector('[role="alert"]');
          alert.textContent = widget.dataset.error;
          alert.hidden = false;
        });
      } finally {
        setBusy(false);
      }
    }
  }
  document.addEventListener('submit', event => {
    if (busy && (event.target.id === 'cart' || event.target.id === 'CartDrawer-Form')) event.preventDefault();
  }, true);
  customElements.define('dtf-locker-pickup', LockerPickup);
})();
